/** Before showing a full-page overlay for a non-report backfill, wait this long. */
export const InitialFullPageDebounceMs = 200;
